import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Dashboard from "./Dashboard";
import "bootstrap/dist/css/bootstrap.css";
import BulkDownload from "./BulkDownload";

const App = () => {
  return (
    <>
      <Header />
      {/* <AttendanceDownloader /> */}
      {/* <BulkDownload /> */}

      <div style={{ display: "flex" }}>
        <Dashboard />
        <div style={{ padding: "20px", flex: 1 }}>
          {/* <h1>Welcome to the Dashboard</h1> */}
        </div>
      </div>
    </>
  );
};

export default App;
